module.exports = __webpack_public_path__ + "static/media/createOrJoin.76d54955.svg";